import type { UrlQueryParamsConfig } from '@/config/shared/url-context';

import {
  buildDenylistSet,
  isBrowser,
  isDeniedKey,
  normalizeParamKey,
  parseSearchParams,
} from './utils';

/**
 * Lê `window.location.search`, aplica allow/deny e retorna snapshot sanitizado.
 */
export class QueryParamCollector {
  collect(config: UrlQueryParamsConfig | undefined): Record<string, string> {
    if (!config || config.enabled === false) return {};
    if (!isBrowser()) return {};

    const raw = parseSearchParams(window.location.search);
    const denylist = buildDenylistSet(
      config.denylist,
      config.mergeDefaultDenylist
    );
    const mode = config.mode ?? 'all_except';
    const allowlist = new Set(
      (config.allowlist ?? []).map(normalizeParamKey).filter(Boolean)
    );

    const result: Record<string, string> = {};

    for (const [key, value] of Object.entries(raw)) {
      if (isDeniedKey(key, denylist)) continue;
      if (mode === 'allowlist' && !allowlist.has(normalizeParamKey(key))) {
        continue;
      }
      // valores vazios: omitir (mantém payload limpo)
      if (value === '') continue;
      result[key] = value;
    }

    return result;
  }
}
